import { render, staticRenderFns } from "./dev-charge-order-statistics.vue?vue&type=template&id=236b1583&scoped=true&"
import script from "./dev-charge-order-statistics.vue?vue&type=script&lang=js&"
export * from "./dev-charge-order-statistics.vue?vue&type=script&lang=js&"
import style0 from "./dev-charge-order-statistics.vue?vue&type=style&index=0&id=236b1583&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236b1583",
  null
  
)

export default component.exports